import React, { useState } from 'react';
import { CustomButton } from '@buttons/CustomButton';
import { Box } from '@mui/material';
import { CollaboratorCard } from './CollaboratorCard';

export const Collaborator = () => {
  const [showCard, setshowCard] = useState(false);

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="left"
        marginTop={4}
        paddingBottom="25px"
        // style={{
        //   borderBottomStyle: 'dashed',
        //   borderBottom: '1px dashed #5E6A71',
        // }}
      >
        <CustomButton
          text="¿Eres colaborador de interprotección?"
          onClick={() => {
            setshowCard(!showCard);
          }}
          size={'medium'}
          variant={'text'}
          style={{
            maxWidth: '300px',
            color: '#039ECC',
            fontSize: '14px',
            textTransform: 'none',
            fontWeight: 'normal',
            textDecoration: 'underline',
            padding: '0px',
            marginBottom: '10px',
          }}
        />
        {showCard && <CollaboratorCard />}
      </Box>
    </>
  );
};
